export default __webpack_public_path__ + "static/media/struts.0002e9b8.svg";